define('common/views/error_view',['require','exports','module','base/view','ldsh!../templates/error_view'],function(require, exports, module){
  "use strict";
  var View = require("base/view");
  module.exports = View.extend({
    template: require("ldsh!../templates/error_view"),
    onRender: function(){
      this.$el.i18n();
    }
  });
});

